import { useEffect, useRef } from "react";
import { WS_URL } from "./api";

/** Shared live WebSocket hook (auto-reconnect). onMessage receives parsed JSON events: position | alert | hello. */
export function useLiveSocket(onMessage: (msg: any) => void, onState?: (s: "open" | "closed") => void) {
  const cb = useRef(onMessage);
  cb.current = onMessage;
    useEffect(() => {
    const token = localStorage.getItem("tg_token");
    let ws: WebSocket, timer: any, closed = false;
    const connect = () => {
      ws = new WebSocket(`${WS_URL}?token=${token}`);
      ws.onopen = () => { if (closed) { ws.close(); return; } onState?.("open"); };
      ws.onclose = () => { if (!closed) { onState?.("closed"); timer = setTimeout(connect, 5000); } };
      ws.onerror = () => ws.close();
      ws.onmessage = (ev) => { try { cb.current(JSON.parse(ev.data)); } catch {} };
    };
    connect();
    return () => { closed = true; clearTimeout(timer); if (ws && ws.readyState === WebSocket.OPEN) ws.close(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
